import { Controller } from "@hotwired/stimulus"

// Lays the circles out like a bento box in the space the grid is given. The
// column count that gives the biggest circles wins; among layouts within 3% of
// it, the one with the fewest empty spaces, so three make two and one, and nine
// make three rows of three. Two or more rows spread from top to bottom, so they
// line up with whatever sits beside the grid; one row centres.
const LABEL = 22 // the label's line and the gap above it
const PAD = 16 // a cell's padding, top and bottom or left and right
const GAP_X = 12
const GAP_Y = 8

export default class extends Controller {
  static targets = ["grid"]
  static values = { maxSpot: Number }

  connect() {
    this.fit()
    this.observer = new ResizeObserver(() => this.fit())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    const count = this.gridTarget.children.length
    if (!count) return

    const { clientWidth: width, clientHeight: height } = this.element
    const layouts = Array.from({ length: count }, (_, index) => {
      const cols = index + 1
      const rows = Math.ceil(count / cols)
      const size = Math.min((width - GAP_X * (cols - 1)) / cols - PAD, (height - GAP_Y * (rows - 1)) / rows - LABEL - PAD, this.maxSpotValue)
      return { cols, rows, size, empty: cols * rows - count }
    })
    const biggest = Math.max(...layouts.map((layout) => layout.size))
    const { cols, rows, size } = layouts
      .filter((layout) => layout.size >= biggest * 0.97)
      .sort((a, b) => a.empty - b.empty || b.size - a.size || b.cols - a.cols)[0]

    this.gridTarget.style.setProperty("--cols", cols)
    this.gridTarget.style.setProperty("--spot", `${Math.max(Math.floor(size), 0)}px`)
    this.gridTarget.style.alignContent = rows > 1 ? "space-between" : "center"
  }
}
